import { useState } from "react";
import MapView from "../../components/ui/MapView";
import MapControls from "../../components/ui/MapControls";
import InformationModal from "../../components/ui/InformationModal";
import SelectedFiltersSummary from "../../components/ui/SelectedFiltersSummary";
import {
  DEFAULT_VICTIM_MAP_FILTER,
  type VictimMapFilter,
} from "../../utils/map/victimMapFilter";

export default function MapSection({ hidden }: { hidden?: boolean }) {
  const [selectedTarget, setSelectedTarget] = useState<{
    lat: number;
    lng: number;
  } | null>(null);
  const [victimFilter, setVictimFilter] =
    useState<VictimMapFilter>(DEFAULT_VICTIM_MAP_FILTER);
  const [infoOpen, setInfoOpen] = useState(false);

  return (
    <>
      <MapView selectedTarget={selectedTarget} victimFilter={victimFilter} />
      {!hidden && (
        <MapControls
          onSelectTarget={setSelectedTarget}
          onOpenInfo={() => setInfoOpen(true)}
          victimFilter={victimFilter}
          onVictimFilterChange={setVictimFilter}
        />
      )}
      {!hidden && <SelectedFiltersSummary />}
      <InformationModal open={infoOpen} onClose={() => setInfoOpen(false)} />
    </>
  );
}
